import { CommonModule } from '@angular/common';

import { ChangeDetectorRef, Component } from '@angular/core';

import { FormsModule } from '@angular/forms';

import { PublicHeaderLayoutComponent } from '../../layouts/public-header-layout/public-header-layout.component';

import { PublicFooterLayoutComponent } from '../../layouts/public-footer-layout/public-footer-layout.component';

import { ApplicationItemModel } from '../../core/models/applications/ApplicationItem.model';

import { ApplicationService } from '../../core/services/application.service';

import { Router } from '@angular/router';

import { CategoryModel } from '../../core/models/categories/Category.model';
import { MarketBannerItem } from '../../core/models/market-hero-slide/MarketBannerItem';


@Component({

    selector: 'app-market',

    standalone: true,

    imports: [

        CommonModule,

        FormsModule,

        PublicHeaderLayoutComponent,

        PublicFooterLayoutComponent

    ],

    templateUrl: './market.component.html',

    styleUrl: './market.component.css'

})

export class MarketComponent {

    searchText = '';

    selectedCategory: CategoryModel | null = null;

    /*

     * null = Seçili ana kategoride belirli bir alt kategori seçili değil.

     */

    selectedSubCategory: CategoryModel | null = null;

    /*

     * ============================================================

     * BANNER STATE

     * ============================================================

     */

    activeBannerIndex = 0;

    activeBannerImageIndex = 0;

    cartCount = 2;

    categories: CategoryModel[] = [];

    products: ApplicationItemModel[] = [];

    bannerItems: MarketBannerItem[] = [];

    private readonly mainCategoryAliases: Record<string, string[]> = {    };

    private readonly subCategoryAliases: Record<string, string[]> = {    };

    constructor(appSvc: ApplicationService, private router: Router, private readonly cdr: ChangeDetectorRef) {

        appSvc.GetCategories().subscribe((data) => {

            if (data.isError) {

                alert(data.msg);

                return;

            }

            this.categories = Array.isArray(data.data) ? data.data : [];

            this.selectedCategory = this.categories.find(category => this.isAllCategory(category)) ?? this.categories[0] ?? null;

            this.selectedSubCategory = null;

            this.cdr.detectChanges();

        });

        appSvc.GetAllApplications().subscribe((data) => {

            if (data.isError) {

                alert(data.msg);

                return;

            }

            this.products = Array.isArray(data.data) ? data.data : [];

            this.cdr.detectChanges();

        });

        appSvc.GetBanners().subscribe((data) => {

            if (data.isError) {

                alert(data.msg);

                return;

            }

            this.bannerItems =  data.data;
            this.activeBannerIndex = 0;
            this.activeBannerImageIndex = 0;

            this.cdr.detectChanges();

        });

    }

    get activeBanner(): any | null {

        if (this.bannerItems.length === 0) {
            return null;
        }

        return this.bannerItems[this.activeBannerIndex] ?? this.bannerItems[0] ?? null;

    }

    get activeVendor(): any | null {

        return this.activeBanner?.vendor ?? null;

    }

    get activeBannerImage(): string {

        const images: string[] = this.activeVendor?.images ?? [];

        if (images.length === 0) {
            return '';
        }

        return images[this.activeBannerImageIndex] ?? images[0] ?? '';

    }

    get filteredProducts(): ApplicationItemModel[] {

        return this.products.filter((product) => {

            if (!this.productMatchesSelectedCategory(product)) {

                return false;

            }

            if (!this.productMatchesSearch(product)) {

                return false;

            }

            return true;

        });

    }

    get categoryContentTitle(): string {

        if (this.selectedSubCategory) {

            return this.selectedSubCategory.name;

        }

        if (this.selectedCategory && !this.isAllCategory(this.selectedCategory)) {

            return this.selectedCategory.name;

        }

        return 'Tüm Ürünler';

    }

    get categoryContentDescription(): string {

        if (this.selectedSubCategory) {

            return `${this.selectedSubCategory.name} kategorisindeki ürünleri keşfedin.`;

        }

        if (this.selectedCategory && !this.isAllCategory(this.selectedCategory)) {

            return `${this.selectedCategory.name} kategorisindeki tüm ürünleri keşfedin.`;

        }

        return 'ANAMETA ekosistemindeki tüm uygulama, servis, oyun ve dijital ürünleri keşfedin.';

    }

    onSearch(value: string): void {

        this.searchText = value;

    }

    clearSearch(): void {

        this.searchText = '';

    }

    private productMatchesSearch(product: ApplicationItemModel): boolean {

        const search = this.normalizeText(this.searchText);

        if (!search) {

            return true;

        }

        const productText = this.getProductSearchText(product);

        /*

         * Birden fazla kelime yazılırsa hepsinin bulunması gerekir.

         *

         * Örnek:

         * anameta ai

         */

        const searchWords = search

            .split(' ')

            .map(x => x.trim())

            .filter(x => x.length > 0);

        return searchWords.every(word => productText.includes(word));

    }


    selectCategory(category: CategoryModel): void {

        this.selectedCategory = category;

        /*

         * Ana kategori değişince daima alt kategori Tümü.

         */

        this.selectedSubCategory = null;

    }

    selectSubCategory(subCategory: CategoryModel | null): void {

        this.selectedSubCategory = subCategory;

    }

    isMainCategorySelected(category: CategoryModel): boolean {

        if (!this.selectedCategory) {

            return false;

        }

        return this.selectedCategory.key === category.key;

    }

    isAllSubCategoriesSelected(): boolean {

        return this.selectedSubCategory === null;

    }

    isSubCategorySelected(subCategory: CategoryModel): boolean {

        if (!this.selectedSubCategory) {

            return false;

        }

        return this.selectedSubCategory.key === subCategory.key;

    }

    getBootstrapIconClass(icon: string | null | undefined): string {

        const value = (icon ?? '').trim();

        if (!value) {
            return 'bi bi-grid';
        }

        if (value === 'bi') {
            return 'bi bi-grid';
        }

        if (value.startsWith('bi ')) {
            return value;
        }

        if (value.startsWith('bi-')) {
            return `bi ${value}`;
        }

        return `bi bi-${value}`;

    }

    private isAllCategory(category: CategoryModel | null | undefined): boolean {

        if (!category) {

            return false;

        }

        const categoryName = this.normalizeText(category.name);

        return categoryName === 'tum' || categoryName === 'tumu' || categoryName === 'all';

    }

    private productMatchesSelectedCategory(product: ApplicationItemModel): boolean {

        /*

         * Backend'den gelen "Tümü" ana kategorisi seçiliyse

         * bütün ürünleri göster.

         */

        if (!this.selectedCategory || this.isAllCategory(this.selectedCategory)) {

            return true;

        }

        /*

         * Belirli bir alt kategori seçilmiş.

         */

        if (this.selectedSubCategory) {

            return this.productMatchesCategory(product, this.selectedSubCategory);

        }

        /*

         * Ana kategori seçilmiş fakat alt kategori = Tümü.

         */

        return this.productMatchesMainCategory(product, this.selectedCategory);

    }

    private productMatchesMainCategory(product: ApplicationItemModel, category: CategoryModel): boolean {

        if (this.isAllCategory(category)) {

            return true;

        }

        const productText = this.getProductSearchText(product);

        const categoryName = this.normalizeText(category.name);

        const mainAliases = this.mainCategoryAliases[categoryName] ?? [];

        /*

         * Önce ana kategori alias'larına bak.

         */

        if (mainAliases.some(alias => productText.includes(this.normalizeText(alias)))) {

            return true;

        }

        /*

         * Sonra alt kategorilerinden herhangi biri ürünle eşleşiyorsa

         * ürünü ana kategori içinde göster.

         */

        if (category.subCategories?.length > 0) {

            return category.subCategories.some(

                subCategory => this.productMatchesCategory(product, subCategory)

            );

        }

        /*

         * Son fallback ana kategori adıdır.

         */

        return productText.includes(categoryName);

    }

    private productMatchesCategory(product: ApplicationItemModel, category: CategoryModel): boolean {

        const productText = this.getProductSearchText(product);

        const categoryName = this.normalizeText(category.name);

        const aliases = this.subCategoryAliases[categoryName] ?? [];

        /*

         * Category adı birebir ürün içinde geçiyorsa.

         */

        if (productText.includes(categoryName)) {

            return true;

        }

        /*

         * Teknik alias eşleşmeleri.

         */

        return aliases.some(alias => {

            const normalizedAlias = this.normalizeText(alias);

            return productText.includes(normalizedAlias);

        });

    }

    getProductCount(category: CategoryModel): number {

        return this.products.filter(

            product => this.productMatchesCategory(product, category)

        ).length;

    }

    getSelectedCategoryProductCount(): number {

        if (!this.selectedCategory || this.isAllCategory(this.selectedCategory)) {

            return this.products.length;

        }

        return this.products.filter(

            product => this.productMatchesMainCategory(product, this.selectedCategory!)

        ).length;

    }

    private getProductSearchText(product: ApplicationItemModel): string {

        const parts: string[] = [

            String(product.pid ?? ''),

            product.id ?? '',

            product.name ?? '',

            product.vendor ?? '',

            product.applicationTypeText ?? '',

            product.applicationCategoryText ?? '',

            product.shortDescription ?? '',

            product.routeLink ?? ''

        ];

        if (product.tags?.length > 0) {

            product.tags.forEach(tag => {

                parts.push(

                    tag.icon ?? '',

                    tag.label ?? '',

                    tag.value ?? ''

                );

            });

        }

        return this.normalizeText(parts.join(' '));

    }

    private normalizeText(value: string | null | undefined): string {

        if (!value) {

            return '';

        }

        return value

            .toLocaleLowerCase('tr-TR')

            .normalize('NFD')

            .replace(/[\u0300-\u036f]/g, '')

            .replace(/ı/g, 'i')

            .replace(/ş/g, 's')

            .replace(/ğ/g, 'g')

            .replace(/ü/g, 'u')

            .replace(/ö/g, 'o')

            .replace(/ç/g, 'c')

            .replace(/\s+/g, ' ')

            .trim();

    }

    previousPromo(): void {

        if (this.bannerItems.length === 0) {

            return;

        }

        this.activeBannerIndex =

            this.activeBannerIndex === 0

                ? this.bannerItems.length - 1

                : this.activeBannerIndex - 1;

        /*

         * Vendor değişti.

         * Yeni vendor'ın ilk bannerına dön.

         */

        this.activeBannerImageIndex = 0;

    }

    nextPromo(): void {

        if (this.bannerItems.length === 0) {

            return;

        }

        this.activeBannerIndex =

            this.activeBannerIndex === this.bannerItems.length - 1

                ? 0

                : this.activeBannerIndex + 1;

        /*

         * Vendor değişti.

         * Yeni vendor'ın ilk bannerına dön.

         */

        this.activeBannerImageIndex = 0;

    }

    selectBanner(index: number): void {

        if (index < 0 || index >= this.bannerItems.length) {

            return;

        }

        this.activeBannerIndex = index;

        /*

         * Yeni vendor seçildiğinde

         * ilk banner fotoğrafını göster.

         */

        this.activeBannerImageIndex = 0;

    }

    selectBannerImage(index: number): void {

        const images: string[] = this.activeVendor?.images ?? [];

        if (index < 0 || index >= images.length) {

            return;

        }

        this.activeBannerImageIndex = index;

    }

    previousHero(): void {

        this.previousPromo();

    }

    nextHero(): void {

        this.nextPromo();

    }

    selectHero(index: number): void {

        this.selectBanner(index);

    }

    selectPromo(index: number): void {

        this.selectBannerImage(index);

    }

    toggleFavorite(product: ApplicationItemModel): void {

        product.isFavorite = !product.isFavorite;

    }

    gotoDetaile(id: string): void {

  
      window.open(`/application/${id}`, '_blank');
    }

 


}